import { functionsHost } from '../firebase'

export const attendeeBookEndpoint = functionsHost + 'inviteUserToEvent'
export const attendeeCancelEndpoint = functionsHost + 'removeUserFromEvent'